import { render, staticRenderFns } from "./myFooter.vue?vue&type=template&id=15e34b47&scoped=true&"
import script from "./myFooter.vue?vue&type=script&lang=js&"
export * from "./myFooter.vue?vue&type=script&lang=js&"
import style0 from "./myFooter.vue?vue&type=style&index=0&id=15e34b47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e34b47",
  null
  
)

export default component.exports